let H = !1;
const U = [], q = (r) => new Promise((e, t) => {
  if (typeof window > "u" || (window.storyblokRegisterEvent = (o) => {
    if (window.location === window.parent.location) {
      console.warn("You are not in Draft Mode or in the Visual Editor.");
      return;
    }
    H ? o() : U.push(o);
  }, document.getElementById("storyblok-javascript-bridge"))) return;
  const s = document.createElement("script");
  s.async = !0, s.src = r, s.id = "storyblok-javascript-bridge", s.onerror = (o) => t(o), s.onload = (o) => {
    U.forEach((n) => n()), H = !0, e(o);
  }, document.getElementsByTagName("head")[0].appendChild(s);
});
var X = Object.defineProperty, W = (r, e, t) => e in r ? X(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, p = (r, e, t) => W(r, typeof e != "symbol" ? e + "" : e, t);
class Q extends Error {
  constructor(e) {
    super(e), this.name = "AbortError";
  }
}
function Z(r, e, t) {
  if (!Number.isFinite(e))
    throw new TypeError("Expected `limit` to be a finite number");
  if (!Number.isFinite(t))
    throw new TypeError("Expected `interval` to be a finite number");
  const s = [];
  let o = [], n = 0, i = !1;
  const l = async () => {
    n++;
    const h = s.shift();
    if (h)
      try {
        const d = await r(...h.args);
        h.resolve(d);
      } catch (d) {
        h.reject(d);
      }
    const u = setTimeout(() => {
      n--, s.length > 0 && l(), o = o.filter((d) => d !== u);
    }, t);
    o.includes(u) || o.push(u);
  }, a = (...h) => i ? Promise.reject(
    new Error(
      "Throttled function is already aborted and not accepting new promises"
    )
  ) : new Promise((u, d) => {
    s.push({
      resolve: u,
      reject: d,
      args: h
    }), n < e && l();
  });
  return a.abort = () => {
    i = !0, o.forEach(clearTimeout), o = [], s.forEach(
      (h) => h.reject(() => new Q("Throttle function aborted"))
    ), s.length = 0;
  }, a;
}
let O = class {
  constructor() {
    p(this, "isCDNUrl", (r = "") => r.includes("/cdn/")), p(this, "getOptionsPage", (r, e = 25, t = 1) => ({
      ...r,
      per_page: e,
      page: t
    })), p(this, "delay", (r) => new Promise((e) => setTimeout(e, r))), p(this, "arrayFrom", (r = 0, e) => Array.from({ length: r }, e)), p(this, "range", (r = 0, e = r) => {
      const t = Math.abs(e - r) || 0, s = r < e ? 1 : -1;
      return this.arrayFrom(t, (o, n) => n * s + r);
    }), p(this, "asyncMap", async (r, e) => Promise.all(r.map(e))), p(this, "flatMap", (r = [], e) => r.map(e).reduce((t, s) => [...t, ...s], [])), p(this, "escapeHTML", function(r) {
      const e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, t = /[&<>"']/g, s = new RegExp(t.source);
      return r && s.test(r) ? r.replace(t, (o) => e[o]) : r;
    });
  }
  /**
   * @method stringify
   * @param  {object} params
   * @param  {string} prefix
   * @param  {boolean} isArray
   * @return {string} Stringified object
   */
  stringify(r, e, t) {
    const s = [];
    for (const o in r) {
      if (!Object.prototype.hasOwnProperty.call(r, o))
        continue;
      const n = r[o], i = t ? "" : encodeURIComponent(o);
      let l;
      typeof n == "object" ? l = this.stringify(
        n,
        e ? e + encodeURIComponent(`[${i}]`) : i,
        Array.isArray(n)
      ) : l = `${e ? e + encodeURIComponent(`[${i}]`) : i}=${encodeURIComponent(n)}`, s.push(l);
    }
    return s.join("&");
  }
  /**
   * @method getRegionURL
   * @param  {string} regionCode region code, could be eu, us, cn, ap or ca
   * @return {string} The base URL of the region
   */
  getRegionURL(r) {
    const e = "api.storyblok.com", t = "api-us.storyblok.com", s = "app.storyblokchina.cn", o = "api-ap.storyblok.com", n = "api-ca.storyblok.com";
    switch (r) {
      case "us":
        return t;
      case "cn":
        return s;
      case "ap":
        return o;
      case "ca":
        return n;
      default:
        return e;
    }
  }
};
const ee = function(r, e) {
  const t = {};
  for (const s in r) {
    const o = r[s];
    e.includes(s) && o !== null && (t[s] = o);
  }
  return t;
}, te = (r) => r === "email", re = () => ({
  singleTag: "hr"
}), se = () => ({
  tag: "blockquote"
}), oe = () => ({
  tag: "ul"
}), ne = (r) => ({
  tag: [
    "pre",
    {
      tag: "code",
      attrs: r.attrs
    }
  ]
}), ie = () => ({
  singleTag: "br"
}), ae = (r) => ({
  tag: `h${r.attrs.level}`
}), le = (r) => ({
  singleTag: [
    {
      tag: "img",
      attrs: ee(r.attrs, ["src", "alt", "title"])
    }
  ]
}), ce = () => ({
  tag: "li"
}), he = () => ({
  tag: "ol"
}), ue = () => ({
  tag: "p"
}), de = (r) => ({
  tag: [
    {
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": r.attrs.name,
        emoji: r.attrs.emoji
      }
    }
  ]
}), pe = () => ({
  tag: "b"
}), ge = () => ({
  tag: "s"
}), me = () => ({
  tag: "u"
}), fe = () => ({
  tag: "strong"
}), ye = () => ({
  tag: "code"
}), be = () => ({
  tag: "i"
}), ke = (r) => {
  if (!r.attrs)
    return {
      tag: ""
    };
  const e = new O().escapeHTML, t = { ...r.attrs }, { linktype: s = "url" } = r.attrs;
  if (delete t.linktype, t.href && (t.href = e(r.attrs.href || "")), te(s) && (t.href = `mailto:${t.href}`), t.anchor && (t.href = `${t.href}#${t.anchor}`, delete t.anchor), t.custom) {
    for (const o in t.custom)
      t[o] = t.custom[o];
    delete t.custom;
  }
  return {
    tag: [
      {
        tag: "a",
        attrs: t
      }
    ]
  };
}, ve = (r) => ({
  tag: [
    {
      tag: "span",
      attrs: r.attrs
    }
  ]
}), $e = () => ({
  tag: "sub"
}), Te = () => ({
  tag: "sup"
}), we = (r) => ({
  tag: [
    {
      tag: "span",
      attrs: r.attrs
    }
  ]
}), Re = (r) => {
  var e;
  return (e = r.attrs) != null && e.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `background-color:${r.attrs.color};`
        }
      }
    ]
  } : {
    tag: ""
  };
}, Se = (r) => {
  var e;
  return (e = r.attrs) != null && e.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `color:${r.attrs.color}`
        }
      }
    ]
  } : {
    tag: ""
  };
}, _e = {
  nodes: {
    horizontal_rule: re,
    blockquote: se,
    bullet_list: oe,
    code_block: ne,
    hard_break: ie,
    heading: ae,
    image: le,
    list_item: ce,
    ordered_list: he,
    paragraph: ue,
    emoji: de
  },
  marks: {
    bold: pe,
    strike: ge,
    underline: me,
    strong: fe,
    code: ye,
    italic: be,
    link: ke,
    styled: ve,
    subscript: $e,
    superscript: Te,
    anchor: we,
    highlight: Re,
    textStyle: Se
  }
}, Ee = function(r) {
  const e = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }, t = /[&<>"']/g, s = new RegExp(t.source);
  return r && s.test(r) ? r.replace(t, (o) => e[o]) : r;
};
let z = !1;
class je {
  constructor(e) {
    p(this, "marks"), p(this, "nodes"), e || (e = _e), this.marks = e.marks || [], this.nodes = e.nodes || [];
  }
  addNode(e, t) {
    this.nodes[e] = t;
  }
  addMark(e, t) {
    this.marks[e] = t;
  }
  render(e, t = { optimizeImages: !1 }, s = !0) {
    if (!z && s && (console.warn(
      "Warning ⚠️: The RichTextResolver class is deprecated and will be removed in the next major release. Please use the `@storyblok/richtext` package instead. https://github.com/storyblok/richtext/"
    ), z = !0), e && e.content && Array.isArray(e.content)) {
      let o = "";
      return e.content.forEach((n) => {
        o += this.renderNode(n);
      }), t.optimizeImages ? this.optimizeImages(o, t.optimizeImages) : o;
    }
    return console.warn(
      `The render method must receive an Object with a "content" field.
      The "content" field must be an array of nodes as the type ISbRichtext.
      ISbRichtext:
        content?: ISbRichtext[]
        marks?: ISbRichtext[]
        attrs?: any
        text?: string
        type: string
        
        Example:
        {
          content: [
            {
              content: [
                {
                  text: 'Hello World',
                  type: 'text'
                }
              ],
              type: 'paragraph'
            }
          ],
          type: 'doc'
        }`
    ), "";
  }
  optimizeImages(e, t) {
    let s = 0, o = 0, n = "", i = "";
    typeof t != "boolean" && (typeof t.width == "number" && t.width > 0 && (n += `width="${t.width}" `, s = t.width), typeof t.height == "number" && t.height > 0 && (n += `height="${t.height}" `, o = t.height), (t.loading === "lazy" || t.loading === "eager") && (n += `loading="${t.loading}" `), typeof t.class == "string" && t.class.length > 0 && (n += `class="${t.class}" `), t.filters && (typeof t.filters.blur == "number" && t.filters.blur >= 0 && t.filters.blur <= 100 && (i += `:blur(${t.filters.blur})`), typeof t.filters.brightness == "number" && t.filters.brightness >= -100 && t.filters.brightness <= 100 && (i += `:brightness(${t.filters.brightness})`), t.filters.fill && (t.filters.fill.match(/[0-9A-F]{6}/gi) || t.filters.fill === "transparent") && (i += `:fill(${t.filters.fill})`), t.filters.format && ["webp", "png", "jpeg"].includes(t.filters.format) && (i += `:format(${t.filters.format})`), typeof t.filters.grayscale == "boolean" && t.filters.grayscale && (i += ":grayscale()"), typeof t.filters.quality == "number" && t.filters.quality >= 0 && t.filters.quality <= 100 && (i += `:quality(${t.filters.quality})`), t.filters.rotate && [90, 180, 270].includes(t.filters.rotate) && (i += `:rotate(${t.filters.rotate})`), i.length > 0 && (i = `/filters${i}`))), n.length > 0 && (e = e.replace(/<img/g, `<img ${n.trim()}`));
    const l = s > 0 || o > 0 || i.length > 0 ? `${s}x${o}${i}` : "";
    return e = e.replace(
      /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g,
      `a.storyblok.com/f/$1/$2.$3/m/${l}`
    ), typeof t != "boolean" && (t.sizes || t.srcset) && (e = e.replace(/<img.*?src=["|'](.*?)["|']/g, (a) => {
      var h, u;
      const d = a.match(
        /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g
      );
      if (d && d.length > 0) {
        const g = {
          srcset: (h = t.srcset) == null ? void 0 : h.map((y) => {
            if (typeof y == "number")
              return `//${d}/m/${y}x0${i} ${y}w`;
            if (typeof y == "object" && y.length === 2) {
              let w = 0, I = 0;
              return typeof y[0] == "number" && (w = y[0]), typeof y[1] == "number" && (I = y[1]), `//${d}/m/${w}x${I}${i} ${w}w`;
            }
            return "";
          }).join(", "),
          sizes: (u = t.sizes) == null ? void 0 : u.map((y) => y).join(", ")
        };
        let R = "";
        return g.srcset && (R += `srcset="${g.srcset}" `), g.sizes && (R += `sizes="${g.sizes}" `), a.replace(/<img/g, `<img ${R.trim()}`);
      }
      return a;
    })), e;
  }
  renderNode(e) {
    const t = [];
    e.marks && e.marks.forEach((o) => {
      const n = this.getMatchingMark(o);
      n && n.tag !== "" && t.push(this.renderOpeningTag(n.tag));
    });
    const s = this.getMatchingNode(e);
    return s && s.tag && t.push(this.renderOpeningTag(s.tag)), e.content ? e.content.forEach((o) => {
      t.push(this.renderNode(o));
    }) : e.text ? t.push(Ee(e.text)) : s && s.singleTag ? t.push(this.renderTag(s.singleTag, " /")) : s && s.html ? t.push(s.html) : e.type === "emoji" && t.push(this.renderEmoji(e)), s && s.tag && t.push(this.renderClosingTag(s.tag)), e.marks && e.marks.slice(0).reverse().forEach((o) => {
      const n = this.getMatchingMark(o);
      n && n.tag !== "" && t.push(this.renderClosingTag(n.tag));
    }), t.join("");
  }
  renderTag(e, t) {
    return e.constructor === String ? `<${e}${t}>` : e.map((s) => {
      if (s.constructor === String)
        return `<${s}${t}>`;
      {
        let o = `<${s.tag}`;
        if (s.attrs) {
          for (const n in s.attrs)
            if (Object.prototype.hasOwnProperty.call(s.attrs, n)) {
              const i = s.attrs[n];
              i !== null && (o += ` ${n}="${i}"`);
            }
        }
        return `${o}${t}>`;
      }
    }).join("");
  }
  renderOpeningTag(e) {
    return this.renderTag(e, "");
  }
  renderClosingTag(e) {
    return e.constructor === String ? `</${e}>` : e.slice(0).reverse().map((t) => t.constructor === String ? `</${t}>` : `</${t.tag}>`).join("");
  }
  getMatchingNode(e) {
    const t = this.nodes[e.type];
    if (typeof t == "function")
      return t(e);
  }
  getMatchingMark(e) {
    const t = this.marks[e.type];
    if (typeof t == "function")
      return t(e);
  }
  renderEmoji(e) {
    if (e.attrs.emoji)
      return e.attrs.emoji;
    const t = [
      {
        tag: "img",
        attrs: {
          src: e.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }
    ];
    return this.renderTag(t, " /");
  }
}
const A = je;
class Ie {
  constructor(e) {
    p(this, "baseURL"), p(this, "timeout"), p(this, "headers"), p(this, "responseInterceptor"), p(this, "fetch"), p(this, "ejectInterceptor"), p(this, "url"), p(this, "parameters"), p(this, "fetchOptions"), this.baseURL = e.baseURL, this.headers = e.headers || new Headers(), this.timeout = e != null && e.timeout ? e.timeout * 1e3 : 0, this.responseInterceptor = e.responseInterceptor, this.fetch = (...t) => e.fetch ? e.fetch(...t) : fetch(...t), this.ejectInterceptor = !1, this.url = "", this.parameters = {}, this.fetchOptions = {};
  }
  /**
   *
   * @param url string
   * @param params ISbStoriesParams
   * @returns Promise<ISbResponse | Error>
   */
  get(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("get");
  }
  post(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("post");
  }
  put(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("put");
  }
  delete(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("delete");
  }
  async _responseHandler(e) {
    const t = [], s = {
      data: {},
      headers: {},
      status: 0,
      statusText: ""
    };
    e.status !== 204 && await e.json().then((o) => {
      s.data = o;
    });
    for (const o of e.headers.entries())
      t[o[0]] = o[1];
    return s.headers = { ...t }, s.status = e.status, s.statusText = e.statusText, s;
  }
  async _methodHandler(e) {
    let t = `${this.baseURL}${this.url}`, s = null;
    if (e === "get") {
      const a = new O();
      t = `${this.baseURL}${this.url}?${a.stringify(
        this.parameters
      )}`;
    } else
      s = JSON.stringify(this.parameters);
    const o = new URL(t), n = new AbortController(), { signal: i } = n;
    let l;
    this.timeout && (l = setTimeout(() => n.abort(), this.timeout));
    try {
      const a = await this.fetch(`${o}`, {
        method: e,
        headers: this.headers,
        body: s,
        signal: i,
        ...this.fetchOptions
      });
      this.timeout && clearTimeout(l);
      const h = await this._responseHandler(
        a
      );
      return this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(h)) : this._statusHandler(h);
    } catch (a) {
      return {
        message: a
      };
    }
  }
  setFetchOptions(e = {}) {
    Object.keys(e).length > 0 && "method" in e && delete e.method, this.fetchOptions = { ...e };
  }
  eject() {
    this.ejectInterceptor = !0;
  }
  _statusHandler(e) {
    const t = /20[0-6]/g;
    return new Promise((s, o) => {
      if (t.test(`${e.status}`))
        return s(e);
      const n = {
        message: e.statusText,
        status: e.status,
        response: Array.isArray(e.data) ? e.data[0] : e.data.error || e.data.slug
      };
      o(n);
    });
  }
}
const xe = Ie, D = "SB-Agent", L = {
  defaultAgentName: "SB-JS-CLIENT",
  defaultAgentVersion: "SB-Agent-Version",
  packageVersion: "6.0.0"
};
let x = {};
const E = {};
class Oe {
  /**
   *
   * @param config ISbConfig interface
   * @param pEndpoint string, optional
   */
  constructor(e, t) {
    p(this, "client"), p(this, "maxRetries"), p(this, "retriesDelay"), p(this, "throttle"), p(this, "accessToken"), p(this, "cache"), p(this, "helpers"), p(this, "resolveCounter"), p(this, "relations"), p(this, "links"), p(this, "richTextResolver"), p(this, "resolveNestedRelations"), p(this, "stringifiedStoriesCache");
    let s = e.endpoint || t;
    if (!s) {
      const i = new O().getRegionURL, l = e.https === !1 ? "http" : "https";
      e.oauthToken ? s = `${l}://${i(e.region)}/v1` : s = `${l}://${i(e.region)}/v2`;
    }
    const o = new Headers();
    o.set("Content-Type", "application/json"), o.set("Accept", "application/json"), e.headers && (e.headers.constructor.name === "Headers" ? e.headers.entries().toArray() : Object.entries(e.headers)).forEach(([i, l]) => {
      o.set(i, l);
    }), o.has(D) || (o.set(D, L.defaultAgentName), o.set(
      L.defaultAgentVersion,
      L.packageVersion
    ));
    let n = 5;
    e.oauthToken && (o.set("Authorization", e.oauthToken), n = 3), e.rateLimit && (n = e.rateLimit), e.richTextSchema ? this.richTextResolver = new A(e.richTextSchema) : this.richTextResolver = new A(), e.componentResolver && this.setComponentResolver(e.componentResolver), this.maxRetries = e.maxRetries || 10, this.retriesDelay = 300, this.throttle = Z(
      this.throttledRequest.bind(this),
      n,
      1e3
    ), this.accessToken = e.accessToken || "", this.relations = {}, this.links = {}, this.cache = e.cache || { clear: "manual" }, this.helpers = new O(), this.resolveCounter = 0, this.resolveNestedRelations = e.resolveNestedRelations || !0, this.stringifiedStoriesCache = {}, this.client = new xe({
      baseURL: s,
      timeout: e.timeout || 0,
      headers: o,
      responseInterceptor: e.responseInterceptor,
      fetch: e.fetch
    });
  }
  setComponentResolver(e) {
    this.richTextResolver.addNode("blok", (t) => {
      let s = "";
      return t.attrs.body && t.attrs.body.forEach((o) => {
        s += e(o.component, o);
      }), {
        html: s
      };
    });
  }
  parseParams(e) {
    return e.token || (e.token = this.getToken()), e.cv || (e.cv = E[e.token]), Array.isArray(e.resolve_relations) && (e.resolve_relations = e.resolve_relations.join(",")), typeof e.resolve_relations < "u" && (e.resolve_level = 2), e;
  }
  factoryParamOptions(e, t) {
    return this.helpers.isCDNUrl(e) ? this.parseParams(t) : t;
  }
  makeRequest(e, t, s, o, n) {
    const i = this.factoryParamOptions(
      e,
      this.helpers.getOptionsPage(t, s, o)
    );
    return this.cacheResponse(e, i, void 0, n);
  }
  get(e, t, s) {
    t || (t = {});
    const o = `/${e}`, n = this.factoryParamOptions(o, t);
    return this.cacheResponse(o, n, void 0, s);
  }
  async getAll(e, t, s, o) {
    const n = (t == null ? void 0 : t.per_page) || 25, i = `/${e}`.replace(/\/$/, ""), l = s ?? i.substring(i.lastIndexOf("/") + 1), a = 1, h = await this.makeRequest(
      i,
      t,
      n,
      a,
      o
    ), u = h.total ? Math.ceil(h.total / n) : 1, d = await this.helpers.asyncMap(
      this.helpers.range(a, u),
      (g) => this.makeRequest(i, t, n, g + 1, o)
    );
    return this.helpers.flatMap([h, ...d], (g) => Object.values(g.data[l]));
  }
  post(e, t, s) {
    const o = `/${e}`;
    return Promise.resolve(
      this.throttle("post", o, t, s)
    );
  }
  put(e, t, s) {
    const o = `/${e}`;
    return Promise.resolve(
      this.throttle("put", o, t, s)
    );
  }
  delete(e, t, s) {
    const o = `/${e}`;
    return Promise.resolve(
      this.throttle("delete", o, t, s)
    );
  }
  getStories(e, t) {
    return this._addResolveLevel(e), this.get("cdn/stories", e, t);
  }
  getStory(e, t, s) {
    return this._addResolveLevel(t), this.get(`cdn/stories/${e}`, t, s);
  }
  getToken() {
    return this.accessToken;
  }
  ejectInterceptor() {
    this.client.eject();
  }
  _addResolveLevel(e) {
    typeof e.resolve_relations < "u" && (e.resolve_level = 2);
  }
  _cleanCopy(e) {
    return JSON.parse(JSON.stringify(e));
  }
  _insertLinks(e, t, s) {
    const o = e[t];
    o && o.fieldtype === "multilink" && o.linktype === "story" && typeof o.id == "string" && this.links[s][o.id] ? o.story = this._cleanCopy(this.links[s][o.id]) : o && o.linktype === "story" && typeof o.uuid == "string" && this.links[s][o.uuid] && (o.story = this._cleanCopy(this.links[s][o.uuid]));
  }
  /**
   *
   * @param resolveId A counter number as a string
   * @param uuid The uuid of the story
   * @returns string | object
   */
  getStoryReference(e, t) {
    return this.relations[e][t] ? (this.stringifiedStoriesCache[t] || (this.stringifiedStoriesCache[t] = JSON.stringify(
      this.relations[e][t]
    )), JSON.parse(this.stringifiedStoriesCache[t])) : t;
  }
  _insertRelations(e, t, s, o) {
    s.includes(`${e.component}.${t}`) && (typeof e[t] == "string" ? e[t] = this.getStoryReference(o, e[t]) : Array.isArray(e[t]) && (e[t] = e[t].map((n) => this.getStoryReference(o, n)).filter(Boolean)));
  }
  iterateTree(e, t, s) {
    const o = (n) => {
      if (n != null) {
        if (n.constructor === Array)
          for (let i = 0; i < n.length; i++)
            o(n[i]);
        else if (n.constructor === Object) {
          if (n._stopResolving)
            return;
          for (const i in n)
            (n.component && n._uid || n.type === "link") && (this._insertRelations(
              n,
              i,
              t,
              s
            ), this._insertLinks(
              n,
              i,
              s
            )), o(n[i]);
        }
      }
    };
    o(e.content);
  }
  async resolveLinks(e, t, s) {
    let o = [];
    if (e.link_uuids) {
      const n = e.link_uuids.length, i = [], l = 50;
      for (let a = 0; a < n; a += l) {
        const h = Math.min(n, a + l);
        i.push(e.link_uuids.slice(a, h));
      }
      for (let a = 0; a < i.length; a++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          by_uuids: i[a].join(",")
        })).data.stories.forEach(
          (h) => {
            o.push(h);
          }
        );
    } else
      o = e.links;
    o.forEach((n) => {
      this.links[s][n.uuid] = {
        ...n,
        _stopResolving: !0
      };
    });
  }
  async resolveRelations(e, t, s) {
    let o = [];
    if (e.rel_uuids) {
      const n = e.rel_uuids.length, i = [], l = 50;
      for (let a = 0; a < n; a += l) {
        const h = Math.min(n, a + l);
        i.push(e.rel_uuids.slice(a, h));
      }
      for (let a = 0; a < i.length; a++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          by_uuids: i[a].join(","),
          excluding_fields: t.excluding_fields
        })).data.stories.forEach((h) => {
          o.push(h);
        });
    } else
      o = e.rels;
    o && o.length > 0 && o.forEach((n) => {
      this.relations[s][n.uuid] = {
        ...n,
        _stopResolving: !0
      };
    });
  }
  /**
   *
   * @param responseData
   * @param params
   * @param resolveId
   * @description Resolves the relations and links of the stories
   * @returns Promise<void>
   *
   */
  async resolveStories(e, t, s) {
    var o, n;
    let i = [];
    if (this.links[s] = {}, this.relations[s] = {}, typeof t.resolve_relations < "u" && t.resolve_relations.length > 0 && (typeof t.resolve_relations == "string" && (i = t.resolve_relations.split(",")), await this.resolveRelations(e, t, s)), t.resolve_links && ["1", "story", "url", "link"].includes(t.resolve_links) && ((o = e.links) != null && o.length || (n = e.link_uuids) != null && n.length) && await this.resolveLinks(e, t, s), this.resolveNestedRelations)
      for (const l in this.relations[s])
        this.iterateTree(
          this.relations[s][l],
          i,
          s
        );
    e.story ? this.iterateTree(e.story, i, s) : e.stories.forEach((l) => {
      this.iterateTree(l, i, s);
    }), this.stringifiedStoriesCache = {}, delete this.links[s], delete this.relations[s];
  }
  async cacheResponse(e, t, s, o) {
    const n = this.helpers.stringify({ url: e, params: t }), i = this.cacheProvider();
    if (this.cache.clear === "auto" && t.version === "draft" && await this.flushCache(), t.version === "published" && e !== "/cdn/spaces/me") {
      const l = await i.get(n);
      if (l)
        return Promise.resolve(l);
    }
    return new Promise(async (l, a) => {
      var h;
      try {
        const u = await this.throttle(
          "get",
          e,
          t,
          o
        );
        if (u.status !== 200)
          return a(u);
        let d = { data: u.data, headers: u.headers };
        if ((h = u.headers) != null && h["per-page"] && (d = Object.assign({}, d, {
          perPage: u.headers["per-page"] ? Number.parseInt(u.headers["per-page"]) : 0,
          total: u.headers["per-page"] ? Number.parseInt(u.headers.total) : 0
        })), d.data.story || d.data.stories) {
          const g = this.resolveCounter = ++this.resolveCounter % 1e3;
          await this.resolveStories(d.data, t, `${g}`);
        }
        return t.version === "published" && e !== "/cdn/spaces/me" && await i.set(n, d), d.data.cv && t.token && E[t.token] !== d.data.cv && (await this.flushCache(), E[t.token] = d.data.cv), l(d);
      } catch (u) {
        if (u.response && u.status === 429 && (s = typeof s > "u" ? 0 : s + 1, s < this.maxRetries))
          return console.log(
            `Hit rate limit. Retrying in ${this.retriesDelay / 1e3} seconds.`
          ), await this.helpers.delay(this.retriesDelay), this.cacheResponse(e, t, s).then(l).catch(a);
        a(u);
      }
    });
  }
  throttledRequest(e, t, s, o) {
    return this.client.setFetchOptions(o), this.client[e](t, s);
  }
  cacheVersions() {
    return E;
  }
  cacheVersion() {
    return E[this.accessToken];
  }
  setCacheVersion(e) {
    this.accessToken && (E[this.accessToken] = e);
  }
  clearCacheVersion() {
    this.accessToken && (E[this.accessToken] = 0);
  }
  cacheProvider() {
    switch (this.cache.type) {
      case "memory":
        return {
          get(e) {
            return Promise.resolve(x[e]);
          },
          getAll() {
            return Promise.resolve(x);
          },
          set(e, t) {
            return x[e] = t, Promise.resolve(void 0);
          },
          flush() {
            return x = {}, Promise.resolve(void 0);
          }
        };
      case "custom":
        if (this.cache.custom)
          return this.cache.custom;
      default:
        return {
          get() {
            return Promise.resolve();
          },
          getAll() {
            return Promise.resolve(void 0);
          },
          set() {
            return Promise.resolve(void 0);
          },
          flush() {
            return Promise.resolve(void 0);
          }
        };
    }
  }
  async flushCache() {
    return await this.cacheProvider().flush(), this.clearCacheVersion(), this;
  }
}
const Ue = (r = {}) => {
  const { apiOptions: e } = r;
  if (!e.accessToken) {
    console.error(
      "You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication"
    );
    return;
  }
  return { storyblokApi: new Oe(e) };
}, ze = (r) => {
  if (typeof r != "object" || typeof r._editable > "u")
    return {};
  try {
    const e = JSON.parse(
      r._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, "")
    );
    return e ? {
      "data-blok-c": JSON.stringify(e),
      "data-blok-uid": e.id + "-" + e.uid
    } : {};
  } catch {
    return {};
  }
};
function Ae(r, e) {
  if (!e)
    return { src: r, attrs: {} };
  let t = 0, s = 0;
  const o = {}, n = [];
  function i(a, h, u, d, g) {
    typeof a != "number" || a <= h || a >= u ? console.warn(`[StoryblokRichText] - ${d.charAt(0).toUpperCase() + d.slice(1)} value must be a number between ${h} and ${u} (inclusive)`) : g.push(`${d}(${a})`);
  }
  if (typeof e == "object") {
    if (typeof e.width == "number" && e.width > 0 ? (o.width = e.width, t = e.width) : console.warn("[StoryblokRichText] - Width value must be a number greater than 0"), e.height && typeof e.height == "number" && e.height > 0 ? (o.height = e.height, s = e.height) : console.warn("[StoryblokRichText] - Height value must be a number greater than 0"), e.loading && ["lazy", "eager"].includes(e.loading) && (o.loading = e.loading), e.class && (o.class = e.class), e.filters) {
      const { filters: a } = e || {}, { blur: h, brightness: u, fill: d, format: g, grayscale: R, quality: y, rotate: w } = a || {};
      h && i(h, 0, 100, "blur", n), y && i(y, 0, 100, "quality", n), u && i(u, 0, 100, "brightness", n), d && n.push(`fill(${d})`), R && n.push("grayscale()"), w && [0, 90, 180, 270].includes(e.filters.rotate || 0) && n.push(`rotate(${w})`), g && ["webp", "png", "jpeg"].includes(g) && n.push(`format(${g})`);
    }
    e.srcset && (o.srcset = e.srcset.map((a) => {
      if (typeof a == "number")
        return `${r}/m/${a}x0/${n.length > 0 ? `filters:${n.join(":")}` : ""} ${a}w`;
      if (Array.isArray(a) && a.length === 2) {
        const [h, u] = a;
        return `${r}/m/${h}x${u}/${n.length > 0 ? `filters:${n.join(":")}` : ""} ${h}w`;
      } else {
        console.warn("[StoryblokRichText] - srcset entry must be a number or a tuple of two numbers");
        return;
      }
    }).join(", ")), e.sizes && (o.sizes = e.sizes.join(", "));
  }
  let l = `${r}/m/`;
  return t > 0 && s > 0 && (l = `${l}${t}x${s}/`), n.length > 0 && (l = `${l}filters:${n.join(":")}`), {
    src: l,
    attrs: o
  };
}
var k = /* @__PURE__ */ ((r) => (r.DOCUMENT = "doc", r.HEADING = "heading", r.PARAGRAPH = "paragraph", r.QUOTE = "blockquote", r.OL_LIST = "ordered_list", r.UL_LIST = "bullet_list", r.LIST_ITEM = "list_item", r.CODE_BLOCK = "code_block", r.HR = "horizontal_rule", r.BR = "hard_break", r.IMAGE = "image", r.EMOJI = "emoji", r.COMPONENT = "blok", r))(k || {}), v = /* @__PURE__ */ ((r) => (r.BOLD = "bold", r.STRONG = "strong", r.STRIKE = "strike", r.UNDERLINE = "underline", r.ITALIC = "italic", r.CODE = "code", r.LINK = "link", r.ANCHOR = "anchor", r.STYLED = "styled", r.SUPERSCRIPT = "superscript", r.SUBSCRIPT = "subscript", r.TEXT_STYLE = "textStyle", r.HIGHLIGHT = "highlight", r))(v || {}), G = /* @__PURE__ */ ((r) => (r.TEXT = "text", r))(G || {}), j = /* @__PURE__ */ ((r) => (r.URL = "url", r.STORY = "story", r.ASSET = "asset", r.EMAIL = "email", r))(j || {});
const Ce = [
  "area",
  "base",
  "br",
  "col",
  "embed",
  "hr",
  "img",
  "input",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], Le = (r = {}) => Object.keys(r).map((e) => `${e}="${r[e]}"`).join(" "), Pe = (r = {}) => Object.keys(r).map((e) => `${e}: ${r[e]}`).join("; ");
function Ne(r) {
  return r.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
const B = (r) => Object.fromEntries(Object.entries(r).filter(([e, t]) => t !== void 0));
function Me(r, e = {}, t) {
  const s = Le(e), o = s ? `${r} ${s}` : r;
  return Ce.includes(r) ? `<${o}>` : `<${o}>${Array.isArray(t) ? t.join("") : t || ""}</${r}>`;
}
function De(r = {}) {
  let e = 0;
  const {
    renderFn: t = Me,
    textFn: s = Ne,
    resolvers: o = {},
    optimizeImages: n = !1,
    keyedResolvers: i = !1
  } = r, l = (c) => (m) => {
    const f = m.attrs || {};
    return i && (f.key = `${c}-${e}`), t(c, f, m.children || null);
  }, a = (c) => {
    const { src: m, alt: f, title: b, srcset: T, sizes: $ } = c.attrs || {};
    let S = m, _ = {};
    if (n) {
      const { src: K, attrs: Y } = Ae(m, n);
      S = K, _ = Y;
    }
    i && (_ = {
      ..._,
      key: `img-${e}`
    });
    const J = {
      src: S,
      alt: f,
      title: b,
      srcset: T,
      sizes: $,
      ..._
    };
    return t("img", B(J));
  }, h = (c) => {
    const { level: m, ...f } = c.attrs || {}, b = {
      ...f
    };
    return i && (b.key = `h${m}-${e}`), t(`h${m}`, b, c.children);
  }, u = (c) => {
    var m, f, b, T;
    const $ = t("img", {
      src: (m = c.attrs) == null ? void 0 : m.fallbackImage,
      alt: (f = c.attrs) == null ? void 0 : f.alt,
      style: "width: 1.25em; height: 1.25em; vertical-align: text-top",
      draggable: "false",
      loading: "lazy"
    }), S = {
      "data-type": "emoji",
      "data-name": (b = c.attrs) == null ? void 0 : b.name,
      "data-emoji": (T = c.attrs) == null ? void 0 : T.emoji
    };
    return i && (S.key = `emoji-${e}`), t("span", S, $);
  }, d = (c) => t("pre", {
    ...c.attrs,
    key: `code-${e}`
  }, t("code", { key: `code-${e}` }, c.children || "")), g = (c, m = !1) => ({ text: f, attrs: b }) => {
    const { class: T, id: $, ...S } = b || {}, _ = m ? {
      class: T,
      id: $,
      style: Pe(S) || void 0
    } : b || {};
    return i && (_.key = `${c}-${e}`), t(c, B(_), f);
  }, R = (c) => C(c), y = (c) => {
    const { marks: m, ...f } = c;
    return "text" in c ? m ? m.reduce(
      (b, T) => R({ ...T, text: b }),
      // Fix: Ensure render function returns a string
      R({ ...f, children: f.children })
      // Fix: Cast children to string
    ) : s(f.text) : "";
  }, w = (c) => {
    const { linktype: m, href: f, anchor: b, ...T } = c.attrs || {};
    let $ = "";
    switch (m) {
      case j.ASSET:
      case j.URL:
        $ = f;
        break;
      case j.EMAIL:
        $ = `mailto:${f}`;
        break;
      case j.STORY:
        $ = f;
        break;
    }
    return b && ($ = `${$}#${b}`), t("a", { ...T, href: $, key: `a-${e}` }, c.text);
  }, I = (c) => {
    var m, f;
    return console.warn("[StoryblokRichtText] - BLOK resolver is not available for vanilla usage"), t("span", {
      blok: (m = c == null ? void 0 : c.attrs) == null ? void 0 : m.body[0],
      id: (f = c.attrs) == null ? void 0 : f.id,
      key: `component-${e}`,
      style: "display: none"
    });
  }, F = new Map([
    [k.DOCUMENT, l("div")],
    [k.HEADING, h],
    [k.PARAGRAPH, l("p")],
    [k.UL_LIST, l("ul")],
    [k.OL_LIST, l("ol")],
    [k.LIST_ITEM, l("li")],
    [k.IMAGE, a],
    [k.EMOJI, u],
    [k.CODE_BLOCK, d],
    [k.HR, l("hr")],
    [k.BR, l("br")],
    [k.QUOTE, l("blockquote")],
    [k.COMPONENT, I],
    [G.TEXT, y],
    [v.LINK, w],
    [v.ANCHOR, w],
    [v.STYLED, g("span", !0)],
    [v.BOLD, g("strong")],
    [v.TEXT_STYLE, g("span", !0)],
    [v.ITALIC, g("em")],
    [v.UNDERLINE, g("u")],
    [v.STRIKE, g("s")],
    [v.CODE, g("code")],
    [v.SUPERSCRIPT, g("sup")],
    [v.SUBSCRIPT, g("sub")],
    [v.HIGHLIGHT, g("mark")],
    ...Object.entries(o).map(([c, m]) => [c, m])
  ]);
  function M(c) {
    e += 1;
    const m = F.get(c.type);
    if (!m)
      return console.error("<Storyblok>", `No resolver found for node type ${c.type}`), "";
    if (c.type === "text")
      return m(c);
    const f = c.content ? c.content.map(C) : void 0;
    return m({
      ...c,
      children: f
      // Fix: Update the type of 'children' to Node[]
    });
  }
  function C(c) {
    return Array.isArray(c) ? c.map(M) : M(c);
  }
  return {
    render: C
  };
}
let P, N = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const Be = (r, e, t = {}) => {
  var s;
  const o = !(typeof window > "u") && typeof window.storyblokRegisterEvent < "u", n = +new URL((s = window.location) == null ? void 0 : s.href).searchParams.get(
    "_storyblok"
  ) === r;
  if (!(!o || !n)) {
    if (!r) {
      console.warn("Story ID is not defined. Please provide a valid ID.");
      return;
    }
    window.storyblokRegisterEvent(() => {
      new window.StoryblokBridge(t).on(["input", "published", "change"], (i) => {
        i.action === "input" && i.story.id === r ? e(i.story) : (i.action === "change" || i.action === "published") && i.storyId === r && window.location.reload();
      });
    });
  }
}, qe = (r = {}) => {
  var e, t;
  const {
    bridge: s,
    accessToken: o,
    use: n = [],
    apiOptions: i = {},
    richText: l = {},
    bridgeUrl: a
  } = r;
  i.accessToken = i.accessToken || o;
  const h = { bridge: s, apiOptions: i };
  let u = {};
  n.forEach((g) => {
    u = { ...u, ...g(h) };
  }), a && (N = a);
  const d = !(typeof window > "u") && ((t = (e = window.location) == null ? void 0 : e.search) == null ? void 0 : t.includes("_storyblok_tk"));
  return s !== !1 && d && q(N), P = new A(l.schema), l.resolver && V(P, l.resolver), u;
}, V = (r, e) => {
  r.addNode("blok", (t) => {
    let s = "";
    return t.attrs.body.forEach((o) => {
      s += e(o.component, o);
    }), {
      html: s
    };
  });
}, He = (r) => !r || !(r != null && r.content.some((e) => e.content || e.type === "blok" || e.type === "horizontal_rule")), Ge = (r, e, t) => {
  let s = t || P;
  if (!s) {
    console.error(
      "Please initialize the Storyblok SDK before calling the renderRichText function"
    );
    return;
  }
  return He(r) ? "" : (e && (s = new A(e.schema), e.resolver && V(s, e.resolver)), s.render(r, {}, !1));
}, Ve = () => q(N);
export {
  k as BlockTypes,
  v as MarkTypes,
  A as RichTextResolver,
  _e as RichTextSchema,
  G as TextTypes,
  Ue as apiPlugin,
  He as isRichTextEmpty,
  Ve as loadStoryblokBridge,
  Be as registerStoryblokBridge,
  Ge as renderRichText,
  De as richTextResolver,
  ze as storyblokEditable,
  qe as storyblokInit,
  Be as useStoryblokBridge
};
